import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Scheduling/hooks/useSchedulingUsers.ts
var DEFAULT_CACHE_STRATEGY = "cache-first";
function useSchedulingUsers(args, opts = {}) {
	const fire = typeof opts.fire === "boolean" ? opts.fire : true;
	const { call, data, isCalling } = useRPC(RPCs.Scheduling.GetSchedulingUsers.v1, args, {
		cacheStrategy: opts.cacheStrategy || DEFAULT_CACHE_STRATEGY,
		fire: !!args && fire
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useSchedulingUsers };

//# sourceMappingURL=useSchedulingUsers.js.map